import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { AxiosResponse } from "axios";
import { IConfiguredAlertItem } from "../@types";
import { ErrorResponse } from "../../../requests/@types";
import api from "../../../services/api";
import { show } from "../../../notifications/notifications";
import { NotificationsLevel } from "../../../lib/enums";
import { route } from "../../../shim/jsbridge";
import { configuredAlertsKeys } from "../queryKeys";

const useSaveConfiguredAlert = (alertId?: string) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const {
    mutate,
    error: submitErrors,
    isPending: isSubmitting
  } = useMutation<
    AxiosResponse<IConfiguredAlertItem>,
    ErrorResponse,
    IConfiguredAlertItem
  >({
    mutationFn: (data: IConfiguredAlertItem) =>
      alertId
        ? api.updateSubscription(alertId, data)
        : api.createSubscription(data),
    onSuccess: () => {
      show({
        level: NotificationsLevel.SUCCESS,
        message: "Alert successfully saved."
      });
      navigate(
        route("user_profile_section", {
          section: "alerts_configuration"
        })
      );
      queryClient.invalidateQueries({
        queryKey: configuredAlertsKeys.list
      });
      queryClient.invalidateQueries({
        queryKey: configuredAlertsKeys.detail(alertId)
      });
    },
    onError: () => {
      show({
        level: NotificationsLevel.ERROR,
        message: "Please correct the Alert Form errors."
      });
    }
  });

  return {
    submit: mutate,
    submitErrors,
    isSubmitting
  };
};

export default useSaveConfiguredAlert;
